/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Campusregisterdatasend3Inputs */

const de__field_campusregisterdatasend3 = /** @type {(inputs: _Field_Campusregisterdatasend3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schüler:in-Account für Campus aktiviert`)
};

/**

* @param {_Field_Campusregisterdatasend3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_campusregisterdatasend3 = /** @type {((inputs?: _Field_Campusregisterdatasend3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Campusregisterdatasend3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_campusregisterdatasend3(inputs)
});
export { _field_campusregisterdatasend3 as "_field_campusRegisterDataSend" }